export enum Loaders {
  signIn = "signIn",
  signUp = "signUp",
  bins = "bins",
  self = "self",
  scanImage = "scanImage",
  items = "items",
  coordinatedBind = "coordinatedBind",
  dropBucket = "dropBucket",
  quests = "quests",
}
